import { jsx as _jsx } from "react/jsx-runtime";
import {} from 'react';
import { Text } from '../../primitives/index.js';
export const TagPill = ({ tag }) => {
    return (_jsx(Text, { style: "subtitle3", css: {
            backgroundColor: 'primary5',
            color: 'primary11',
            px: '6px',
            py: '4px',
            borderRadius: '100px',
            fontStyle: 'italic',
            lineHeight: '100%'
        }, children: tag }));
};
//# sourceMappingURL=TagPill.js.map